// extracted by mini-css-extract-plugin
export var compactFilters = "_fg-4";
export var detailImage = "_fg-1";
export var dropdownContainer = "_fg-2";
export var imageContainer = "_fg-0";
export var selectedCard = "_fg-3";